import {
  ElementRef,
  ErrorHandler,
  Injectable,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { BehaviorSubject, Subscription, timer } from "rxjs";
import { FormBuilder } from "@angular/forms";
import { Project } from "../Project";
import { AppHttpClient } from "@common/core/http/app-http-client.service";
import { MatDialogRef } from "@angular/material/dialog";
import { Toast } from "@common/core/ui/toast.service";
import { FtpDetails } from "../../builder-types";
import { Settings } from "@common/core/config/settings.service";
import { HttpClient } from "@angular/common/http";
import { take, takeUntil } from "rxjs/operators";
import { Projects } from "../projects.service";
import { BuilderStateService } from "src/app/html-builder/builder-state.service";
import { CurrentUser } from "@common/auth/current-user";
import { LocalStorage } from "@common/core/services/local-storage.service";
import { Unsub } from "src/app/unsub.class";

@Injectable({
  providedIn: "root",
})
export class ProjectSettingsService extends Unsub {
  loading$ = new BehaviorSubject<boolean>(false);
  dnsForm = this.fb.group({
    publishDestination: "",
    domain_name: "",
  });
  form = this.fb.group({
    formsEmail: "",
    slug: "",
    publishDestination: "",
    customDomainId: null,
    storeCredentials: false,

    builder: this.fb.group({
      autoSave: false,
      selectedContextActions: false,
      hoverContextActions: true,
    }),
    ftpCredentials: this.fb.group({
      host: "",
      username: "",
      password: "",
      directory: "",
      port: 21,
      ssl: false,
      remember: false,
    }),
  });
  project: Project;
  private dialogRef: MatDialogRef<any>;
  minutes: number = 2;
  timer: any;
  @ViewChild("domain_name") domain_name: ElementRef;
  showDomainIsUsed = false;

  constructor(
    private fb: FormBuilder,
    private http: AppHttpClient,
    private toast: Toast,
    private projects: Projects,
    public httpClient: HttpClient,
    private settings: Settings,
    private currentUser: CurrentUser,
    public state: BuilderStateService,
    public errorHandler: ErrorHandler
  ) {
    super();
  }

  timerInterval: any;
  remainingTime: number;
  loading = new BehaviorSubject(false);

  init(project: Project, dialogRef: MatDialogRef<any>) {
    this.project = project;
    this.dialogRef = dialogRef;
    this.hydrateForm();
  }
  removeDotAtEnd(text: string) {
    return text ? text.slice(0, -1) : "";
  }

  submitForm() {
    this.http
      .post(`projects/${this.project.id}/settings`, this.form.value).pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: { project: Project }) => {
        this.dialogRef.close(response.project);
        this.toast.open("Settings saved");
      });
  }
  getProjectDetails(id: number) {
    this.loading.next(true);
    this.projects.get(id).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.loading.next(false);
      console.log("builder project", res);
      this.dialogRef.close(res.project);
    });
  }
  
  cloundfrontConfig(){
    this.loading.next(true);
    this.http
    .post(`projects/${this.project.id}/cloundfront_config`, {...this.project,form_domain_name: this.dnsForm.value.domain_name + '.'}).pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any) => {
      this.loading.next(false);
      console.log(data);
      if(data){
        if(data.status == 'success'){
          this.getProjectDetails(this.project.id);
        }
      }else {
        this.toast.open('Internal server error',{duration: 1500});
      }
      
    },error => {
      this.loading.next(false);
    });
  }
  updateDnsStatus(status: 0 | 1){
    this.loading.next(true);
    this.http
        .post(`projects/${this.project.id}/update-dns-status`, {
          dns_status: status
        }).pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any) => {
          this.loading.next(false);
          console.log("dns status", data);
          if (data.status == "success") {
            
            this.getProjectDetails(this.project.id);
          }
        },error => {
          this.loading.next(false);
        });
  }
  submitDnsForm() {
    
    
    // const pattern = new RegExp('^[a-zA-Z0-9.-]+\.(com|org|net|in|io|co|gov|us)$');
    // const domainText = this.dnsForm.get("domain_name").value;
    // console.log('pattern test ', pattern.test(domainText));
    
    // if (this.dnsForm.get("domain_name").value == this.project.domain_name) {
    //   this.showDomainIsUsed = true;
    //   return;
    // }
    if(this.project.isSSLConfigured == 1){
      this.cloundfrontConfig();
    }else {
      this.loading.next(true);
      this.http
        .post(`projects/${this.project.id}/first-ssl-request`, this.dnsForm.value).pipe(takeUntil(this.unsubscribe$))
        .subscribe((data: any) => {
          
          console.log("first request", data);
          if (data.status == "success") {
            
            this.getProjectDetails(this.project.id);
          }else if(data.errors) {
            
            this.toast.open(data.errors.message,{duration: 2000});
          }
          this.loading.next(false);
        },error => {
          this.loading.next(false);
        });
    }
    
  }

  
  

  private hydrateForm() {
    const formData = { ...this.project.settings };
    const dnsFormData = {
      publishDestination: this.project.publishDestination,
      domain_name: this.project.domain_name || null,
    };
    formData.slug = this.project.slug;

    if (!formData.formsEmail) {
      formData.formsEmail = this.project.users[0].email;
    }

    if (!formData.publishDestination) {
      formData.publishDestination = "default";
    }
    if (!dnsFormData.publishDestination) {
      dnsFormData.publishDestination = "default";
    }

    if (!formData.customDomainId) {
      formData.customDomainId = this.project.domain?.id;
    }

    let ftp = (formData.ftpCredentials || {}) as FtpDetails;
    if (!ftp.host) {
      ftp = this.settings.getJson("publish.default_credentials", {
        port: 21,
        ssl: false,
      });
    }
    if (!ftp.directory) {
      ftp.directory = this.project.slug;
    }

    this.form.patchValue({ ...formData, ftpCredentials: ftp });
    this.dnsForm.patchValue({ ...dnsFormData });
  }
}
